export const TackPinIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M5.6 1.75H10.15L8.75 3.15V6.3L11.2 8.75V9.45H7.7L7 12.25L6.3 9.45H2.8V8.75L5.25 6.3V3.15L3.85 1.75H5.6Z"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
